import React, { Component } from 'react';

import translator from '../../../components/localization/translator';
import {
	KEY_CODES
} from '../../../config/constants';

export default class InputWithLabel extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: this.props.value || ''
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.value !== this.state.value) {
			this.setState({ value: nextProps.value });
		}
	}

	renderLabel() {
		let labelStyle = this.props.labelStyle? this.props.labelStyle : 'label-width';
		if (!this.props.label) {
			return null;
		}
		return (
			<label htmlFor={this.props.htmlFor} className={labelStyle}>
				{translator.translate(this.props.label)}
			</label>
		);
	}

	render() {
		let additionalStyle = this.props.additionalStyle || '',
			inputStyle = this.props.inputStyle ? '' : 'my-custom-input',
			inputMargin = this.props.id === 'receiverPhone' ? 'label-distance' : null,
			phoneWidth = this.props.id === 'receiverPhone' ? 'phone-style' : null;
		if (this.props.style) {
			additionalStyle = `${additionalStyle} padding align-center`;
		}
		return(
			<div className={`display-flex align-center ${additionalStyle} ${phoneWidth}`}>
				{this.renderLabel()}
				<input
					type={this.props.type}
					id={this.props.id}
					value={this.state.value || ''}
					disabled={this.props.disabled}
					onKeyPress={(e) => {
						if (e.target.type === 'number') {
							const keyCode = e.keyCode || e.which;
							if (keyCode === KEY_CODES.dot) {
								if (!this.props.dotsAllowed || !e.target.value) {
									e.preventDefault();
									e.stopPropagation();
									return false;
								}
							} else if ((keyCode < KEY_CODES.zero && keyCode !== KEY_CODES.minus) ||
								keyCode > KEY_CODES.nine ||
								(keyCode === KEY_CODES.zero && !e.target.value) ||
								(keyCode === KEY_CODES.minus && e.target.value)) {
								e.preventDefault();
								e.stopPropagation();
								return false;
							}
						}
					}}
					onChange={(e)=>{
						const value = e.target.value;
						this.setState({value});
						this.props.onChange(e);
					}}
					onWheel={(e) => {
						e.stopPropagation();
					}}
					className={`form-control default-font ${inputStyle} ${inputMargin}`} />
			</div>
		);
	}
}
